import {Component, Input, OnInit} from '@angular/core';
import {ProductTileConfig} from '../../models/product-tile-config';

@Component({
  selector: 'app-product-tile',
  templateUrl: './product-tile.component.html',
  styleUrls: []
})
export class ProductTileComponent implements OnInit {

  @Input() config: ProductTileConfig;

  constructor() { }

  ngOnInit(): void {
  }

}
